import Row from '../common/Row';

const BottomHeader = ({ menus }) => (
  <nav className="border-b border-slate-200 bg-white">
    <Row className="mx-auto w-full max-w-7xl items-center gap-6 overflow-x-auto px-4 py-3 text-sm sm:px-6 lg:px-8">
      {menus.map((item) => <span key={item} className="shrink-0 font-medium text-slate-600 transition hover:text-indigo-600">{item}</span>)}
    </Row>
  </nav>
);

export default BottomHeader;
